module.exports = __webpack_public_path__ + "static/media/affirmations-banner.d640c27e.png";